import { Link, useRouterState } from "@tanstack/react-router";
import { ALL_LOCALES, ACTIVE_LOCALES, LOCALE_LABEL, type Lang } from "@/lib/i18n";

// §8 — language selector must be visible, not hidden. Six IMO slots ready
// from day one; v1 activates EN + RU, the rest render as muted "coming soon"
// pills so the row never reshuffles when FR/ES/ZH/AR ship.

export function LanguagePills({ lang }: { lang: Lang }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const rest = pathname.replace(/^\/[a-z]{2}/, "") || "";

  return (
    <nav
      aria-label="Language"
      className="relative isolate -mt-10 mb-12 md:mb-16"
    >
      <div className="mx-auto max-w-6xl px-5">
        <div className="-mx-5 overflow-x-auto px-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <ul className="flex min-w-max items-center gap-2 snap-x">
            {ALL_LOCALES.map((code) => {
              const active = code === lang;
              const ready = (ACTIVE_LOCALES as readonly Lang[]).includes(code);
              const base =
                "snap-start rounded-full border px-4 py-2 text-sm font-medium whitespace-nowrap transition-colors";
              if (active) {
                return (
                  <li key={code}>
                    <span
                      aria-current="true"
                      className={base}
                      style={{
                        background: "var(--amber)", color: "var(--ink)",
                        borderColor: "var(--amber)",
                      }}
                    >
                      {LOCALE_LABEL[code]}
                    </span>
                  </li>
                );
              }
              if (ready) {
                return (
                  <li key={code}>
                    <Link
                      to={`/${code}${rest}` as string}
                      className={base}
                      style={{
                        background: "var(--paper)", color: "var(--ink)",
                        borderColor: "var(--fog)",
                      }}
                    >
                      {LOCALE_LABEL[code]}
                    </Link>
                  </li>
                );
              }
              return (
                <li key={code}>
                  <span
                    aria-disabled="true"
                    title="Coming soon"
                    className={`${base} opacity-50 cursor-not-allowed`}
                    style={{
                      background: "transparent", color: "var(--fog)",
                      borderColor: "var(--fog)",
                    }}
                  >
                    {LOCALE_LABEL[code]}
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
}